/**
 * HLF Mobile Bottom Toolbar v2 Logic
 */

document.addEventListener('DOMContentLoaded', () => {
  const toolbar = document.querySelector('.hlf-mobile-toolbar');
  if (!toolbar) return;

  const items = toolbar.querySelectorAll('.hlf-toolbar-item');
  const tab5 = toolbar.querySelector('#hlf-toolbar-tab5');
  const aiBotBtn = toolbar.querySelector('#hlf-toolbar-ai-bot');
  const searchBtn = toolbar.querySelector('#hlf-toolbar-search-btn');
  const reorderBtn = toolbar.querySelector('#hlf-toolbar-reorder');
  const accountLabel = toolbar.querySelector('#hlf-toolbar-account-label');

  // ───── AI Shopping Agent (Shadow DOM) Integration ─────
  function setupAgentShadow() {
    const host = document.querySelector('#ads-agent-host');
    if (!host || !host.shadowRoot) return false;

    if (!host.shadowRoot.querySelector('#hlf-agent-mobile-override')) {
      const style = document.createElement('style');
      style.id = 'hlf-agent-mobile-override';
      style.textContent = `
        @media screen and (max-width: 989px) {
          [data-testid="entrypoint"] {
            display: none !important;
            opacity: 0 !important;
            pointer-events: none !important;
            visibility: hidden !important;
            transform: scale(0) !important;
          }
        }
      `;
      host.shadowRoot.appendChild(style);
    }
    return true;
  }

  // Intercept #ads-agent-host when loaded or mutated
  setupAgentShadow();
  try {
    const agentObserver = new MutationObserver(() => {
      setupAgentShadow();
    });
    agentObserver.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  function triggerAiShoppingAgent() {
    // 1. Primary: Look inside #ads-agent-host Shadow DOM
    const host = document.querySelector('#ads-agent-host');
    if (host && host.shadowRoot) {
      setupAgentShadow();
      const sr = host.shadowRoot;

      // If floating view is already open, toggle it closed
      const floatingView = sr.querySelector('[data-testid="floating-view"]') || sr.querySelector('[role="dialog"]');
      if (floatingView) {
        const closeBtn = sr.querySelector('button[aria-label="Close"]')
                      || sr.querySelector('button[aria-label*="close" i]')
                      || floatingView.querySelector('button:last-child');
        if (closeBtn) {
          closeBtn.click();
          return true;
        }
      }

      // Otherwise open the agent
      const btn = sr.querySelector('[data-testid="entrypoint"] [role="button"]')
               || sr.querySelector('[aria-label*="Shopping Agent"]')
               || sr.querySelector('[data-testid="entrypoint"]');

      if (btn) {
        try {
          if (typeof btn.focus === 'function') btn.focus();
          btn.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
          btn.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
          btn.click();
        } catch (err) {
          btn.click();
        }
        return true;
      }
    }

    // 2. Fallback: Main document DOM
    const entrypoint = document.querySelector('[data-testid="entrypoint"]');
    const agentBtn = document.querySelector('[data-testid="entrypoint"] [role="button"]')
                  || document.querySelector('[aria-label*="Shopping Agent"]')
                  || entrypoint;

    if (agentBtn) {
      try {
        if (typeof agentBtn.focus === 'function') agentBtn.focus();
        agentBtn.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
        agentBtn.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
        agentBtn.click();
      } catch (err) {
        agentBtn.click();
      }
      return true;
    }
    return false;
  }

  // 1. Path-based Active State Detection
  const path = window.location.pathname;

  function setActiveTab(activeTabElement) {
    items.forEach(item => item.classList.remove('is-active'));
    if (activeTabElement) {
      activeTabElement.classList.add('is-active');
    }
  }

  function detectActiveTab() {
    // Check Tab 5 (Special) first if a specific link is configured
    if (tab5) {
      const tab5Href = tab5.getAttribute('href');
      if (tab5Href && tab5Href !== '/' && tab5Href !== '#' && path.startsWith(tab5Href)) {
        setActiveTab(tab5);
        return;
      }
    }

    // Check Search
    if (path.startsWith('/search')) {
      const searchTab = toolbar.querySelector('[data-tab="search"]');
      if (searchTab) {
        setActiveTab(searchTab);
        return;
      }
    }

    // Check Reorder / Account
    if (path.startsWith('/account') || path.startsWith('/pages/reorder') || path.startsWith('/orders') || path.startsWith('/pages/kp-account')) {
      const reorderTab = toolbar.querySelector('[data-tab="reorder"]');
      if (reorderTab) {
        setActiveTab(reorderTab);
        return;
      }
    }

    // Check Shop / Collections
    if (path.startsWith('/collections') || path.startsWith('/products')) {
      const shopTab = toolbar.querySelector('[data-tab="shop"]');
      if (shopTab) {
        setActiveTab(shopTab);
        return;
      }
    }

    // Check Home
    if (path === '/' || path === '') {
      const homeTab = toolbar.querySelector('[data-tab="home"]');
      if (homeTab) {
        setActiveTab(homeTab);
        return;
      }
    }
  }

  detectActiveTab();

  // 2. Click Handling & Instant Active State Toggle
  items.forEach(item => {
    item.addEventListener('click', function(e) {
      // Tab 3: AI Bot (Trigger Original Shopping Agent)
      if (item === aiBotBtn) {
        e.preventDefault();
        // Do NOT call setActiveTab to keep tab clean without any indicator or shadow

        const triggered = triggerAiShoppingAgent();
        if (!triggered) {
          // Poll briefly if agent widget script is still initializing
          let attempts = 0;
          const pollTimer = setInterval(() => {
            attempts++;
            if (triggerAiShoppingAgent() || attempts >= 30) {
              clearInterval(pollTimer);
            }
          }, 100);
        }
        return;
      }

      // Tab 3 Fallback: Search
      if (item === searchBtn && !path.startsWith('/search')) {
        const popup = document.querySelector('hlf-search-popup');
        if (popup && typeof popup.open === 'function') {
          e.preventDefault();
          setActiveTab(searchBtn);
          popup.open();
          return;
        }

        const searchModalTrigger = document.querySelector('summary.header__icon--search, details-modal.header__search summary, [data-open-search]');
        if (searchModalTrigger) {
          e.preventDefault();
          setActiveTab(searchBtn);
          searchModalTrigger.click();
          setTimeout(() => {
            const searchInput = document.querySelector('.search-modal input[type="search"], .search__input');
            if (searchInput) searchInput.focus();
          }, 150);
          return;
        }
      }

      // Tab 4: Reorder (KwikPass Engage Orders / Reorder)
      if (item === reorderBtn) {
        e.preventDefault();
        setActiveTab(reorderBtn);

        const customAccountPage = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('isCustomAccountPage')) || '/pages/kp-account';
        const reorderTarget = customAccountPage.replace(/\/+$/, '') + '/orders';

        const customerId = (typeof getCustomerId === 'function') ? getCustomerId() : null;
        const kpToken = (typeof getValueFromCookiesOrLocalStorage === 'function' && typeof XGokwikCoreToken === 'function' && window.merchantInfo)
          ? getValueFromCookiesOrLocalStorage(XGokwikCoreToken(window.merchantInfo.environment))
          : null;

        if (customerId != null || kpToken) {
          window.location.href = reorderTarget;
        } else if (typeof handleKpAndShopifyLogin === 'function') {
          handleKpAndShopifyLogin(reorderTarget);
        } else {
          window.location.href = reorderTarget;
        }
        return;
      }

      // Tab 5: Special Tab (NEXT GEN)
      // When clicked, immediately remove color and activate top bar indicator
      if (item === tab5) {
        setActiveTab(tab5);
        const href = tab5.getAttribute('href');
        if (!href || href === '#' || href === 'javascript:void(0);' || href === path) {
          e.preventDefault();
        }
        return;
      }

      // Standard tabs
      setActiveTab(item);
    });
  });

  // 3. Update account label if user logged in
  function autoLoginToolbar() {
    if (accountLabel && accountLabel.textContent.trim().toUpperCase() === 'LOGIN') {
      accountLabel.textContent = 'ACCOUNT';
    }
  }

  const userToken = localStorage.getItem('KWIKSESSIONTOKEN') || localStorage.getItem('kp_sso_token');
  if (userToken) {
    autoLoginToolbar();
  }

  window.addEventListener('user-loggedin', function(event) {
    if (event?.detail?.token) {
      autoLoginToolbar();
    }
  });
});
